module.exports = __webpack_public_path__ + "static/media/index-video-heart2.c1ed7ed8.png";